$(document).ready(function() {
  $(document).on('click', '.checkboxes .checkboxes__option', function() {
    if ($(this).hasClass('checked')) $(this).removeClass('checked');
    else $(this).addClass('checked');
  });

  $(document).on('click', '.radio-buttons .radio-buttons__option', function() {
    const parent = $(this).closest('.radio-buttons');
    parent.find('.radio-buttons__option').removeClass('checked');
    $(this).addClass('checked');
  });
});
